export function isAndroid() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("android") > -1 && ua.indexOf("mobile");
}

export function isIOS() {
  return (
    ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

export function isMobileAppSupportedDevice() {
  return isAndroid() || isIOS();
}
